/**
 * Image preview row component
 * Shows horizontal scrollable list of attached images
 */

import React from 'react';
import { css } from '@emotion/react';
import { colors, spacing } from '../../../styles';
import ImageThumbnail, { AttachedImage } from './ImageThumbnail';

interface ImagePreviewRowProps {
  images: AttachedImage[];
  onRemove: (id: string) => void;
}

const ImagePreviewRow: React.FC<ImagePreviewRowProps> = ({ images, onRemove }) => {
  if (images.length === 0) {
    return null;
  }

  return (
    <div css={containerStyle}>
      <div css={labelStyle}>Attached Images</div>
      <div css={thumbnailsStyle}>
        {images.map((image) => (
          <ImageThumbnail key={image.id} image={image} onRemove={() => onRemove(image.id)} />
        ))}
      </div>
    </div>
  );
};

const containerStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.centi};
  padding-bottom: ${spacing.centi};
`;

const labelStyle = css`
  font-size: 14px;
  color: ${colors.tungsten};
  font-weight: 500;
`;

const thumbnailsStyle = css`
  display: flex;
  gap: ${spacing.centi};
  overflow-x: auto;
  padding-top: 8px; /* Space for remove button positioned at top: -6px */
  padding-bottom: ${spacing.centi};

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export default ImagePreviewRow;
